import {all} from "redux-saga/effects";
import {combineReducers} from "redux";

import * as auth from "../app/auth/_redux/authRedux";
import {slice as meatsSlice} from "../app/meats/_redux/slice";
import {slice as meatsCategoriesSlice} from "../app/_redux/meatsCategories/slice";
import {slice as supplementsSlice} from "../app/supplements/_redux/slice";
import {slice as adminsSlice} from "../app/admins/_redux/slice";
import {slice as usersSlice} from "../app/users/_redux/slice";
import {slice as equipmentsSlice} from "../app/equipments/_redux/slice";
import {slice as musclesSlice} from "../app/muscles/_redux/slice";
import {slice as musicSlice} from "../app/music/_redux/slice";
import {slice as exercisesSlice} from "../app/exercises/_redux/slice";
import {slice as workoutsSlice} from "../app/workouts/_redux/slice";
import {slice as plansSlice} from "../app/plans/_redux/slice";
import {slice as blogsSlice} from "../app/blogs/_redux/slice";
import {slice as blogCategoriesSlice} from "../app/blogCategories/_redux/slice";
import {slice as notificationsSlice} from "../app/notifications/_redux/slice";
import {slice as challengeSlice} from "../app/challenge/_redux/slice";

export const rootReducer = combineReducers({
  meats: meatsSlice.reducer,
  meatsCategories: meatsCategoriesSlice.reducer,
  supplements: supplementsSlice.reducer,
  equipments: equipmentsSlice.reducer,
  muscles: musclesSlice.reducer,
  music: musicSlice.reducer,
  workouts: workoutsSlice.reducer,
  plans: plansSlice.reducer,
  exercises: exercisesSlice.reducer,
  admins: adminsSlice.reducer,
  users: usersSlice.reducer,
  blogs: blogsSlice.reducer,
  blog_categories: blogCategoriesSlice.reducer,
  notifications: notificationsSlice.reducer,
  auth: auth.reducer,
  challenge: challengeSlice.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
